import { useMemo } from "react";
// mui
import { CssBaseline, GlobalStyles } from "@mui/material";
import { ThemeProvider as MuiThemeProvider, createTheme } from "@mui/material/styles";
//
import breakpoints from "./breakpoints";
import ComponentsOverride from "./overrides";
import palette from "./palette";
import shadows, { customShadows } from "./shadows";
import typography from "./typography";
import propTypes from "prop-types";
import { faIR } from "@mui/material/locale";
import { useDarkMode } from "src/contexts/them-context/ThemContext";

const ThemePropTypes = {
  children: propTypes.node.isRequired,
};

// Usage:

const ThemeProvider = ({ children }) => {
  // use context
  const { isDarkMode } = useDarkMode();

  const themeOptions = useMemo(
    () => ({
      direction: "rtl",
      palette: isDarkMode ? palette.dark : palette.light,
      typography,
      breakpoints,
      shape: { borderRadius: 8 },
      shadows: isDarkMode ? shadows.dark : shadows.light,
      customShadows: isDarkMode ? customShadows.dark : customShadows.light,
      smoothScroll: {
        animation: "smoothScroll 0.5s ease-in-out", // Define the animation here
      },
    }),
    [isDarkMode]
  );

  ThemeProvider.propTypes = ThemePropTypes;

  const theme = createTheme(themeOptions, faIR);

  theme.components = ComponentsOverride(theme);

  return (
    <MuiThemeProvider theme={theme}>
      <CssBaseline />
      <GlobalStyles
        styles={(theme) => ({
          "*": {
            scrollBehavior: "smooth",
          },
          body: {
            "&::-webkit-scrollbar": {
              width: 12,
            },
            "&::-webkit-scrollbar-track": {
              background: theme.palette.grey[600],
              borderRadius: 8,
            },
            "&::-webkit-scrollbar-thumb": {
              backgroundColor: theme.palette.grey[100],
              borderRadius: 10,
              border: `4px solid ${theme.palette.grey[600]}`,
            },
          },
        })}
      />
      {children}
    </MuiThemeProvider>
  );
};

export default ThemeProvider;
